import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Report.css";
import { Row,Col,Card} from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { InputGroup, Form } from "react-bootstrap";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,BarChart,Bar
} from "recharts";

const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}`;

function Report() {
  const [activeTimeRange, setActiveTimeRange] = useState("1 wk");
  
  const getPastDate = (days) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return d.toISOString().split('T')[0];
  };

  const [startDate, setStartDate] = useState(getPastDate(7));
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  
  const [status, setStatus] = useState("All");

  const handleTimeRangeClick = (range) => {
    setActiveTimeRange(range);
    const end = new Date().toISOString().split('T')[0];
    let start = "";
    if (range === "1 wk") start = getPastDate(7);
    else if (range === "1 mo") start = getPastDate(30);
    else if (range === "3 mo") start = getPastDate(90);
    setStartDate(start);
    setEndDate(end);
  };

  const handleManualDateChange = (isStart, val) => {
    setActiveTimeRange(""); // Un-highlight preset buttons
    if (isStart) setStartDate(val);
    else setEndDate(val);
  };
  const { role } = useAuth();

  const isOperations = role === "operations";
  const isAdmin = role === "admin";

  const [metrics, setMetrics] = useState({
    totalLeads: 0,
    leadsContacted: 0,
    conversions: 0,
    conversionRate: 0,
    chartData: [
      { month: "Jan", value: null }, { month: "Feb", value: null }, { month: "Mar", value: null },
      { month: "Apr", value: null }, { month: "May", value: null }, { month: "Jun", value: null },
      { month: "Jul", value: null }, { month: "Aug", value: null }, { month: "Sep", value: null },
      { month: "Oct", value: null }, { month: "Nov", value: null }, { month: "Dec", value: null }
    ],
    employeeData: []
  });

  const reportRef = useRef(null);

  const handleDownloadPDF = async () => {
    const element = reportRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("Sales_Report.pdf");
    } catch (error) {
      console.error("Failed to generate PDF", error);
    }
  };

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        let url = `${API_BASE_URL}/api/sales-report?`;
        if (startDate && endDate) {
          url += `startDate=${startDate}&endDate=${endDate}`;
        } else {
          url += `timeRange=${activeTimeRange}`;
        }

        const token = localStorage.getItem('token');
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const result = await response.json();
        if (result.success) {
          setMetrics(result.data);
        }
      } catch (err) {
        console.error("Failed to fetch report data:", err);
      }
    };
    fetchReportData();
  }, [startDate, endDate, activeTimeRange]);
  return (
    <>    
       <nav
     aria-label="breadcrumb"
     style={{
       "--bs-breadcrumb-divider": "''",
     }}
   >
     <ol
       className="breadcrumb d-flex align-items-center py-2 mb-0"
       style={{ fontSize: "14px" }}
     >
       <li className="breadcrumb-item d-flex align-items-center">
         <Link to="/" className="text-decoration-none text-secondary">
           Home
         </Link>
         <ChevronRight size={16} className="mx-1 text-secondary" />
       </li>
   
       <li
         className="breadcrumb-item fw-semibold"
         style={{ color: "#2F7A87" }}
       >
Report 
       </li>
     </ol>
   </nav>
    <div className="ms-4 mt-3" ref={reportRef}>
      
      <div className="d-flex align-items-center mb-3">

        <div className="">
          <h4>Sales Report</h4>
          <p className="text-secondary" style={{ fontSize: "14px" }}>
            View assigned queries, track leads, and manage sales activities in one place.
          </p>
        </div>
             <div className="ms-auto p-3">
  <button className="download-btn" onClick={handleDownloadPDF}>
    <i className="bi bi-download me-2"></i>
    Download
  </button>
</div>
      </div>

      <div className=" shadow-sm rounded" style={{
    border: "1px solid rgba(209,213,219,1)",
    borderRadius: "10px",
    background: "#fff"
  }}>
        <div className="d-flex align-items-center flex-wrap">

          <div className="p-3 bg-white rounded mt-4">
            <span>Time Range:</span>

            <div className="btn-group ms-3">
              {["1 wk", "1 mo", "3 mo"].map((range) => (
                <button
                  key={range}
                  className={`btn btn-sm time-btn ${activeTimeRange === range ? "active" : ""}`}
                  onClick={() => handleTimeRangeClick(range)}
                  style={{
                    borderRadius: "30px",
                    marginRight: "8px",
                    backgroundColor: activeTimeRange === range ? "#2F7A87" : "transparent",
                    color: activeTimeRange === range ? "#fff" : "#6c757d",
                    borderColor: activeTimeRange === range ? "#2F7A87" : "#6c757d",
                  }}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>

          <div className="ms-3 bg-white rounded">
            <label htmlFor="startDate" className="form-label mb-0">
              Start
            </label>
            <input
              id="startDate"
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => handleManualDateChange(true, e.target.value)}
              style={{
                width: "150px",
                display: "block",
                borderRadius: "30px",
              }}
            />
          </div>

          <div className="ms-3 bg-white rounded">
            <label htmlFor="endDate" className="form-label mb-0">
              End
            </label>

            <input
              id="endDate"
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => handleManualDateChange(false, e.target.value)}
              style={{
                width: "150px",
                display: "block",
                borderRadius: "30px",
              }}
            />
          </div>



        </div>
      </div>
 <Row className="mb-3 g-3 mt-1">
  {[
    { num: metrics.totalLeads, label: "Total Leads Assigned ", icon: "/images/1 2.svg", iconBg:"#E7F1FF" },
    { num: metrics.leadsContacted, label: "Leads contacted", icon: "/images/2 2.svg", iconBg:"#E8F6E6" },
    { num: metrics.conversions, label: "Conversions", icon: "/images/3 2.svg", iconBg:"#FDE7E7" },
    { num: metrics.conversionRate, label: "Conversion rate", icon: "/images/4 1.svg", iconBg:"#ECECEE" },
  ].map((item, idx) => (
    <Col key={idx} md={3}>
      <Card
        className="border rounded-3 shadow-sm"
        style={{ height: "90px", display: "flex", justifyContent: "center" }}
      >
        <div className="d-flex align-items-center gap-3 px-3">
          
       
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              backgroundColor: item.iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}
          >
            <img src={item.icon} alt="" width="50" height="50" />
          </div>

          <div>
            <div className="fw-bold" style={{ fontSize: "22px" }}>
              {item.num}
            </div>
            <div className="text-muted small">{item.label}</div>
          </div>

        </div>
      </Card>
    </Col>
  ))}
</Row> 
{isAdmin && (
  <Card
    className="border rounded-3 shadow-sm p-4 mb-3"
    style={{
      border: "1px solid rgba(209,213,219,1)",
      background: "#fff"
    }}
  >
    <h5 className="mb-4">Conversions by employees</h5>

<ResponsiveContainer width="100%" height={300}>
<BarChart
  data={metrics.employeeData}
  barCategoryGap="0%"
  barGap={0}
  tabIndex={-1}  
>

    <CartesianGrid strokeDasharray="3 3" vertical={false} />

    <XAxis dataKey="name" tick={{ fontSize: 12 }} />

    <YAxis tick={{ fontSize: 12 }} />

    {/* remove hover background */}
    <Tooltip cursor={{ fill: "transparent" }} />

    <Bar
      dataKey="value"
      fill="#4f9da6"
      radius={[6, 6, 0, 0]}
      barSize={55}
      isAnimationActive={false}
    />

  </BarChart>
</ResponsiveContainer>
  </Card>
)}
<Card
  className="border rounded-3 shadow-sm p-4   col-6"
  style={{
    border: "1px solid rgba(209,213,219,1)",
    background: "#fff"
  }}
>
  <h5 className="mb-4">Conversion rate trend</h5>

  <ResponsiveContainer width="100%" height={365}>
    <LineChart data={metrics.chartData}>

      <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

      <XAxis
        dataKey="month"
        tick={{ fontSize: 13 }}
      />

      <YAxis
        domain={[0, 100]}
        tick={{ fontSize: 13 }}
      />

      <Tooltip />

      <Line
        type="monotone"
        dataKey="value"
        stroke="#2F7A87"
        strokeWidth={3}
        dot={{ r: 4 }}
        connectNulls={false}
      />

    </LineChart>
  </ResponsiveContainer>
</Card>
    </div></>
  );
}

export default Report;